import moment from 'moment';
import omit from 'lodash/omit';
import { Loader } from '@thinknet-gmbh/platform-common-ui';

import { useGetCurrentAccount } from 'src/hooks/accounts/get-current-account.hook';
import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';
import { useGetApplicationById } from 'src/hooks/applications/get-application-by-id.hook';
import { useCreateEauApplication } from 'src/hooks/applications/create-eau-applications.hook';
import { useUpdateStatusEauApplication } from 'src/hooks/applications/update-eua-application.hook';
import { useGetEmployeeById } from 'src/hooks/employees/get-employee-by-id.hook';

import { EauForm } from './components/eau-form';
import { IEau } from '../../eau.interfaces';

const ChangeEau = ({ id, onClose }: { id?: string; onClose: () => void }) => {
  const { application, loading } = useGetApplicationById(id);

  const { createEauApplication, loading: createLoading } = useCreateEauApplication({
    onSuccess: onClose,
  });
  const { updateStatusEauApplication, loading: updateLoading } = useUpdateStatusEauApplication({
    onSuccess: onClose,
  });

  const currentCompanyId = useGetCurrentCompanyId();

  const { account } = useGetCurrentAccount();

  const { _id, firstDay, lastDay, file, ...rest } = application || {};

  const loader = _id ? updateLoading : createLoading;

  const isEdit = application?._id;

  const { employee, loading: empLoading } = useGetEmployeeById(application?.employeeId);

  const initialValue = isEdit
    ? {
        ...rest,
        firstDay: firstDay ? moment(firstDay) : '',
        lastDay: lastDay ? moment(lastDay) : '',
        employeeNumber: employee?.employeePersonalInfo?.employeeNumber,
        ...(file?.location && {
          fileId: {
            file: {
              uid: file.key,
              name: file.filename,
              url: file.location,
            },
            fileList: [
              {
                uid: file.key,
                name: file.filename,
                url: file.location,
              },
            ],
          },
        }),
      }
    : ({} as IEau);

  const onFinish = (values: any) => {
    if (!isEdit) {
      const { fileId, ...rest } = values;

      const isFileValid = fileId && fileId?.file?.status !== 'removed';

      createEauApplication({
        variables: {
          payload: {
            ...omit(rest, ['employeeNumber']),
            companyId: currentCompanyId,
            fileId: isFileValid ? fileId.file : null,
          },
        },
      });
    } else {
      updateStatusEauApplication({
        variables: {
          payload: {
            _id: application._id,
            status: values?.status,
            ...(values?.rejectReason && { rejectReason: values.rejectReason }),
            ...(values?.rejectDetails && { rejectDetails: values.rejectDetails }),
          },
        },
      });
    }
  };

  if (loading || empLoading) return <Loader />;

  return (
    <EauForm
      isEdit={isEdit}
      accountId={account?._id}
      initialValues={initialValue}
      onClose={onClose}
      loading={loader}
      onFinishHandler={onFinish}
      companyId={currentCompanyId}
    />
  );
};

export default ChangeEau;
